<template>
    <div class="row flex-sm-up mt-5">
        <div v-if="!isSharedMode" class="col-sm-12">
            <h1 class="text-center">{{ translations?.MyWishlist }}</h1>
        </div>
        <div v-if="isSharedMode" class="col-sm-12">
            <h1>{{ translations?.SharedWishlist }}</h1>
            <p class="text-small">
                <a alt="favorites url" :href="baseUrl()">[{{ translations?.ViewMyWishlist }}]</a>
            </p>
        </div>
    </div>
    <div class="row flex-sm-up mt-3 mb-4">
        <div v-if="products.length" class="col-sm-12 text-right">
            <ul class="icons-list icons-list--inline icons-list--blue-links v-favorites__sharing">
                <li v-if="!isSharedMode" class="icons-list__item icons-block">
                    <div class="sharethis-inline-share-buttons" data-title="Favorites"></div>
                </li>
            </ul>
        </div>
    </div>
    <div>
        <ul v-if="products.length" class="product-grid mb-5 product-grid--4-col">
            <li v-for="(product, index) in products" :key="product" class="product-grid__item">
                <ProductCard
                    :portfolioType="product.portfolio"
                    :url="product.productDetailUrl"
                    :title="product.productDisplayName"
                    :imageUrl="product.primaryImageUrl"
                    :isFinishImageMissing="product.isFinishImageMissing"
                    :beautyImageUrl="product.beautyImageUrl"
                    :description="product.productBrowseDescription"
                    :availability="product.availability"
                    :modelNumber="product.modelNumber"
                    :index="index"
                    :translations="translations"
                    :product="product"
                    :hasQuickship="product.quickShip"
                    :isDiscontinued="product.isDiscontinued"
                    :disableComparison="true"
                    v-on:favoriteItemRemoved="removeFavoriteProduct"
                ></ProductCard>
            </li>
        </ul>
        <div class="col-12 mb-5 text-center p-3 bg-gray-light" v-else>
            {{ translations?.NoSavedProducts }}
        </div>
        <div class="load-indicator" :class="{ 'state-visible': loadingResults === true }">
            <div class="load-indicator__indicator"></div>
            <span class="load-indicator__text">{{ translations?.Loading }}</span>
        </div>
        <div class="load-indicator-cover" :class="{ 'state-visible': loadingResults === true }"></div>
    </div>
</template>

<script lang="ts">
import ProductCard from 'Vue/components/shared/ProductCard.vue';
import { variantGrouping, wishlistResponse, wishlistTranslations } from 'Vue/interfaces/WishlistInterfaces';
import { GetProductData } from 'Api/apis';

declare var __sharethis__: any;

export default {
    name: 'Wishlist',
    components: {
        ProductCard,
    },
    data() {
        return {
            loadingResults: false,
            ProductIdsString: null,
            ProductIds: [] as string[],
            products: [] as variantGrouping[],
            translations: {} as wishlistTranslations,
        };
    },
    methods: {
        async getWishlistProducts() {
            const queryParams = new URLSearchParams(window.location.search);
            if (queryParams.has('slugs')) {
                this.ProductIdsString = queryParams.has('slugs') ? queryParams.get('slugs') : null;
                this.productIds = this.ProductIdsString.split(',');
                this.isSharedMode = true;
            }
            this.loadingResults = true;
            let request = this.$store.getters?.wishlistRequest;
            this.getAllProductKeys(request);
            if (request.slugs?.length > 0) {
                const responseData: wishlistResponse = await GetProductData(request);
                this.products = responseData.products;
            }
            this.loadingResults = false;
        },
        getAllProductKeys(request): void {
            let keyName = 'wishlist-products';
            if (localStorage.getItem(keyName)) {
                let slugs = JSON.parse(localStorage.getItem(keyName));
                this.productIdsString = slugs.toString();
                // Eliminate any null product Slugs
                for (let i = slugs.length - 1; i >= 0; i--) {
                    if (slugs[i] == null) {
                        slugs.splice(i, 1);
                    }
                }
                request.slugs = slugs;
            }
        },        
        loadShareThis() {  
            const buttons = document.querySelector('.sharethis-inline-share-buttons')
            var newUrl = window.location.href + `?slugs=` + this.productIdsString;
            buttons.setAttribute('data-url', newUrl ) 
            __sharethis__.initialize();
        },
      
        baseUrl() {
            return window.location.pathname;
        },
        doPrint(e) {
            e.preventDefault();
            window.print();
        },
        getTranslations() {
            let wishlistDataDiv = document.getElementById('wishlistTranslationsData');
            return JSON.parse(wishlistDataDiv.getAttribute('data-translations'));
        },
        removeFavoriteProduct: function(product) {
            var index = this.products.findIndex( (i) => i.variantSlug === product.variantSlug);
            if (index !== -1) {
                this.products.splice(index, 1 );
            }
        }
    },
    async created() {
        this.translations = this.getTranslations();
        await this.getWishlistProducts();
        this.loadShareThis();
    },
};
</script>
